import React, { useCallback } from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { deleteBrief } from '@disco/state-management/reducers/entities/briefs'
import DocumentHeadTags from 'components/document-head-tags'
import { Dialog, Flex, Button } from 'components/ds'
import mixpanel from '@disco/api/mixpanel'

export const BriefDeletePage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ briefId: string }>()

  const basePath = location.pathname.includes('brief-editor-v2')
    ? `/brief-editor-v2/${params.briefId!}`
    : '/briefs'

  const handleDelete = useCallback(async () => {
    await dispatch(deleteBrief(parseInt(params.briefId!)))
    mixpanel.sendPureEvent('Brief deleted', {
      Context: 'Briefs',
      brief_id: Number(params.briefId!),
    })
    navigate('/briefs')
  }, [dispatch, navigate, params.briefId])

  const handleCancel = useCallback(() => {
    navigate(basePath)
  }, [navigate, basePath])

  return (
    <div>
      <DocumentHeadTags title="Delete brief | DISCO" />
      <Dialog.Root defaultOpen>
        <Dialog.Content maxWidth="400px">
          <Dialog.Title>Delete this brief?</Dialog.Title>
          <Dialog.Description>
            This will delete the brief and any associated submissions. Briefs
            cannot be recovered once deleted.
          </Dialog.Description>
          <Flex gap="3" mt="4" justify="end">
            <Dialog.Close>
              <Button variant="soft" color="gray" onClick={handleCancel}>
                Cancel
              </Button>
            </Dialog.Close>
            <Dialog.Close onClick={handleDelete}>
              <Button variant="soft" color="red">
                Delete
              </Button>
            </Dialog.Close>
          </Flex>
        </Dialog.Content>
      </Dialog.Root>
    </div>
  )
}

export default BriefDeletePage
